import { Component, OnInit } from '@angular/core';
import { MainConfig } from '../../../conf/main.config';
import { getUiStrings, UiStrings } from '../../i18n/ui';

@Component({
    selector: 'app-footer',
    templateUrl: '../../../custom/footer/footer.html',
    styleUrls: ['../../../custom/footer/footer.css'],
})
export class FooterComponent implements OnInit {
    public MainConfig = MainConfig;
    copy: UiStrings = getUiStrings();
    currentLanguage = 'pt-BR';

    constructor() {}

    ngOnInit(): void {
        this.currentLanguage =
            localStorage.getItem('language') === 'fr' ? 'fr' : 'pt-BR';
    }
}
